import { ExtendedWebflowBenefit } from "../../../types";
import {
  IWebflowBenefitCategory,
  IWebflowBenefitMinimumSubscription
} from "@wingspanhq/cms/dist/lib/interfaces";
import {
  SubscriptionPackage,
  SubscriptionPackageTier
} from "@wingspanhq/users/dist/lib/interfaces";
import { OAI_KEY, PLAN_DETAILS } from "../../../utils/constants";

const { monthlyPremiumFormatted, name } = PLAN_DETAILS[OAI_KEY];

export const getOAIBenefitListItem = (): ExtendedWebflowBenefit => {
  const benefit: ExtendedWebflowBenefit = {
    icon: "shield-check-fill",
    iconColor: "white",
    iconBackgroundColor: "garnet",
    helperLogo: {
      src: "",
      placeholder: ""
    },
    logo: {
      src: "",
      placeholder: ""
    },
    mainVideo: {
      src: ""
    },
    collectionId: "",
    editedOn: new Date(),
    isDraft: false,
    name,
    itemId: "",
    publishedOn: new Date(),
    slug: OAI_KEY,
    category: IWebflowBenefitCategory.Insurance,
    minSubscription: IWebflowBenefitMinimumSubscription.Benefits,
    minSubscriptionPackage: SubscriptionPackage.Benefits,
    minSubscriptionPackageTier: SubscriptionPackageTier.Basic,
    atAGlance: "Your financial safety net for on-the-job accidents",
    featured: false,
    helperCostDescription: `While enrolled, ${monthlyPremiumFormatted} of your gross earnings are deducted from each payment processed through Wingspan`,
    shortCostDescription: `${monthlyPremiumFormatted} of gross income`,
    helperCostIsNotIncluded: true,
    helperHideMemberAndGroupInfo: true,
    isAdditionalCoverage: true,
    hidden: false,
    mainDescription: null,
    mainFAQSItems: "",
    mainHeader: name,
    orderPriority: 10,
    isAssurely: true
  };

  return benefit;
};
